import {
  ChakraBox,
  coalesceNoteContentToHtml,
  EditorV2,
  EditorV2State,
} from '@equip.health/ui';

import { PatientNoteItemTemplateRevisionForm } from '~/components/maud/patients/note/PatientNoteItemTemplateRevisionForm';
import { PatientNoteListItemType } from '~/lib/constants/AddPatientNoteModal.constants';
import { useEffect, useRef } from 'react';
import './EditorV2ReadonlyStyles.css';

type Props = {
  noteExternalId: string;
  noteContent?: string;
  noteTemplateRevision?: PatientNoteListItemType['noteTemplateRevision'];
  noteTemplateRevisionData?: Record<string, unknown>;
};
export const PatientNoteItemContent = ({
  noteExternalId,
  noteContent,
  noteTemplateRevision,
  noteTemplateRevisionData,
}: Props) => {
  const noteContentEditorRef = useRef<EditorV2State>(null);

  const htmlNoteContent: string | null = noteContent
    ? coalesceNoteContentToHtml(noteContent)
    : null;

  useEffect(() => {
    noteContentEditorRef.current?.chain().setContent(htmlNoteContent).run();
  }, [htmlNoteContent]);

  return (
    <>
      {!noteTemplateRevision?.templateRevisionId && htmlNoteContent && (
        <ChakraBox className="editor-v2-readonly">
          <EditorV2
            hideBorder
            initialContent={htmlNoteContent}
            readOnly
            stateRef={noteContentEditorRef}
          />
        </ChakraBox>
      )}
      {noteTemplateRevision?.templateRevisionId && (
        <PatientNoteItemTemplateRevisionForm
          noteId={noteExternalId}
          noteTemplateRevisionId={noteTemplateRevision.templateRevisionId}
          noteTemplateRevisionData={noteTemplateRevisionData}
        />
      )}
    </>
  );
};
